/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Harsh Event Icon component.
 */
export const HarshEventIcon = ({color = dlsColor('red')}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68783 13.9963 2.00371 11.3122 2 8Z' fill={iconColor}/>
      <path fillRule='evenodd' clipRule='evenodd' d='M12 8L4 5L5.90476 8L4 11L12 8Z' fill='white'/>
    </svg>
  );
};

export default HarshEventIcon;
